'use client'

import { useCallback } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { signOut } from 'next-auth/react'

import { useCartStore } from 'modules/cart'
import { PATHS } from 'shared/utils/paths'
import { LocalStorage } from 'shared/utils/storage'

/**
 * Ends the session and drops every trace of the customer left on this device:
 * - the cart is dropped,
 * - the query cache and local storage cleared
 */
export const useEndCustomerSession = () => {
  const { setCart, cleanup } = useCartStore()
  const queryClient = useQueryClient()

  return useCallback(
    async (onSignedOut?: () => void) => {
      setCart(null)
      cleanup()

      await signOut({ callbackUrl: PATHS.home })
      queryClient.clear()
      LocalStorage.clear()
      onSignedOut?.()
    },
    [setCart, cleanup, queryClient]
  )
}
